/** Document type. */
export class DocumentType {
  constructor(data) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.description = data.description;
    this.backgroundImage = data.backgroundImage;
  }

  /**
   * Map to readable
   * @param {DocumentType} value Value.
   * @returns {string}
   */
  static toReadable(value) {
    return value.name;
  }
}
